/* eslint-disable no-magic-numbers */
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'sort',
})
export class ArraySortPipe implements PipeTransform {
  transform(array: any[], field?: string, reverse?: boolean): any[] {
    if (!Array.isArray(array)) return [];
    array.sort((a: any, b: any) => {
      if (field) {
        if (_.get(a, field) < _.get(b, field)) return -1;
        else if (_.get(a, field) > _.get(b, field)) return 1;
        else return 0;
      } else {
        if (a < b) return -1;
        else if (a > b) return 1;
        else return 0;
      }
    });
    if (reverse) array.reverse();
    return array;
  }
}